import React from 'react';
import { Box, FormControl, FormLabel, Radio, RadioGroup } from '@mui/material';
import { Uniform } from '../../../../components/uniform/uniform';
import { UniformStepContainer } from '../../../../components/uniform/uniform-step-container';
import { UniformStep } from '../../../../components/uniform/uniform-step';
import { Accordion, AccordionSummary, AccordionDetails } from '../../../../components/accordion';
import { Row } from '../../../../components/row';
import { Cell } from '../../../../components/cell';
import { TextField } from '../../../../components/text-field';
import { CompanyLookup } from '../../../../components/lookups';
import { RadioOption } from '../../../../components/radio-group';
import { YesNo } from '../../../../components/radio-group/yes-no-component';
import { ICompanyLookup } from '../../../../components/lookups/company-lookup/interfaces';
import { ReadonlyInput } from '../../../../components/readonly-input';
import { ClassroomTitlezone } from './classroom-titlezone';
import { ClassroomLaunchbox } from './classroom-launchbox';

export interface ClassroomState {
  name?: string;
  companyId?: string;
  isActive: boolean;
}

export interface ClassroomErrors {
  name?: string;
  companyId?: string;
}

interface IClassroomComponentProps {
  isEditMode: boolean;
  isReadOnly: boolean;
  isSaving: boolean;
  classroom: ClassroomState;
  errors: ClassroomErrors;
  onSaveClick: () => void;
  onValidate: () => boolean;
  onNameChange: (name: string) => void;
  onCompanyChange: (company?: ICompanyLookup) => void;
  onIsActiveChange: (isActive: boolean) => void;
}

export function ClassroomComponent(props: IClassroomComponentProps) {
  const { isEditMode, isReadOnly, isSaving, classroom, errors, onSaveClick, onValidate, onNameChange, onCompanyChange, onIsActiveChange } = props;
  const { name, companyId, isActive } = classroom;

  function handleIsActiveChange(event: React.ChangeEvent<HTMLInputElement>) {
    onIsActiveChange(event.target.value === YesNo.Yes);
  }

  return (
    <Uniform
      titleZone={<ClassroomTitlezone isEditMode={isEditMode} />}
      launchbox={<ClassroomLaunchbox isReadOnly={isReadOnly} isSaving={isSaving} onSave={onSaveClick} onValidate={onValidate} />}
      isEditMode={isEditMode}
      showButtons={!isEditMode}
      onOk={onSaveClick}
      onCancel={() => window.close()}
      okButtonIsLoading={isSaving}
      showSpinnerOnNextAndComplete={isSaving}
    >
      <UniformStep stepName="Generelt" validate={onValidate}>
        <UniformStepContainer>
          <Accordion defaultExpanded>
            <AccordionSummary>Lokale</AccordionSummary>
            <AccordionDetails>
              <Box mt={1}>
                <Row>
                  <Cell size="full">
                    {!isReadOnly ? (
                      <TextField
                        variant="outlined"
                        value={name}
                        label="Lokalenavn"
                        onChange={event => onNameChange(event.target.value)}
                        required
                        error={!!errors.name}
                        errorText={errors.name}
                      />
                    ) : (
                      <ReadonlyInput label="Lokalenavn" value={name} />
                    )}
                  </Cell>
                </Row>
                <Row>
                  <Cell size="full">
                    <CompanyLookup label="Virksomhed" value={companyId} onChange={onCompanyChange} required error={!!errors.companyId} errorText={errors.companyId} readOnly={isReadOnly} />
                  </Cell>
                </Row>
                <Row>
                  <Cell size="full">
                    {!isReadOnly ? (
                      <FormControl component="fieldset" sx={{ paddingLeft: 1.7 }}>
                        <FormLabel id="active-radios" component="legend">
                          Aktiv
                        </FormLabel>
                        <RadioGroup aria-labelledby="active-radios" row name="isActive" value={isActive ? YesNo.Yes : YesNo.No} onChange={handleIsActiveChange}>
                          <RadioOption value={YesNo.Yes} control={<Radio />} label="Ja" />
                          <RadioOption value={YesNo.No} control={<Radio />} label="Nej" />
                        </RadioGroup>
                      </FormControl>
                    ) : (
                      <ReadonlyInput label="Aktiv" value={isActive ? 'Ja' : 'Nej'} />
                    )}
                  </Cell>
                </Row>
              </Box>
            </AccordionDetails>
          </Accordion>
        </UniformStepContainer>
      </UniformStep>
    </Uniform>
  );
}
